import styles from './departments-table.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import {
  TableContainer,
  TableHeader,
  TableBodyContainer,
  TableBodyLine,
  PaginationButtons,
  IconEdit,
  IconDeleteCircle,
  Button
} from '@touche-lts/panel-ui/dist'
import { PictureNameLine } from 'components'
import { DepartmentsTableSortProps } from 'mobx-stores/departments/departments-table/departments-table-store.types'
import { useGetScrollWidth } from 'hooks/custom-hooks'
import { departmentTableWidths } from './departments-table-page.utils'

const DepartmentsTableComponent = (props) => { // TODO-A To add a model
  const { className, style } = props

  const {
    departmentsTableStore: {
      triggerSearch,
      searchResults,
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      paginationInfo
    },
    departmentsStore: {
      onSuspendDepartmentClick,
    },

    routingStore: { push }
  } = useRootStore()

  useEffect(() => {
    triggerSearch({ resetPageNumber: true })
  }, [triggerSearch])

  const {scrollX, handleScroll} = useGetScrollWidth()

  return (
    <TableContainer className={cl(className, styles.thinScroll)} style={{...style, overflowX: 'auto'}} onScroll={handleScroll}>
      <TableHeader
        tableColumns={[
          {
            label: 'departments',
            isColumnMarked: isColumnMarked(DepartmentsTableSortProps.DEPARTMEMENTS),
            sortDirection: getSortDirection(DepartmentsTableSortProps.DEPARTMEMENTS),
            setSortDirection: handleSortDirectionChange(
              DepartmentsTableSortProps.DEPARTMEMENTS
            ),
            inputProps: {
              placeholder: 'Search...',
              value: searchProps.name,
              onChange: name => onSearchPropsChange({ name })
            },
            widthPx: departmentTableWidths.DEPARTMENTS
          },
          {
            label: 'categories',
            isColumnMarked: isColumnMarked(DepartmentsTableSortProps.CATEGORIES),
            widthPx: departmentTableWidths.CATEGORIES
          },
          {
            label: 'subcategories',
            isColumnMarked: isColumnMarked(DepartmentsTableSortProps.SUBCATEGORIES),
            widthPx: departmentTableWidths.SUBCATEGORIES
            
          },
          {
            label: 'types',
            isColumnMarked: isColumnMarked(DepartmentsTableSortProps.TYPES),
            widthPx: departmentTableWidths.TYPES
          },
          {
            label: 'subtypes',
            isColumnMarked: isColumnMarked(DepartmentsTableSortProps.SUBTYPES),
            widthPx: departmentTableWidths.SUBTYPES
          },
          {
            label: 'actions',
            widthPx: 120,
          },

        ]}
      />
      <TableBodyContainer className={styles.tableBodyContainer}>
        {searchResults.map(store => {
          return (
            <TableBodyLine
              key={store.id}
              className={styles.rowClicable}
              cells={[
                {
                  children:
                    <PictureNameLine
                      imageSrc={store?.squareCrop?.url}
                      imageBoxShadow
                      name={store.name}
                    />,
                  onClick: () => push('/departments/' + store.id),
                  widthPx: departmentTableWidths.DEPARTMENTS
                },
                {
                  children: <span className={cl(styles.lightTag)}>{store?.categoryCount} categories</span>,
                  onClick: () => push('/departments/' + store.id),
                  widthPx: departmentTableWidths.CATEGORIES
                },
                {
                  children: <span className={cl(styles.lightTag)}>{store?.subcategoryCount} subcategories</span>,
                  onClick: () => push('/departments/' + store.id),
                  widthPx: departmentTableWidths.SUBCATEGORIES
                },
                {
                  children: <span className={cl(styles.lightTag)}>{store?.typeCount} types</span>,
                  onClick: () => push('/departments/' + store.id),
                  widthPx: departmentTableWidths.TYPES
                },
                {
                  children: <span className={cl(styles.lightTag)}>{store?.subtypeCount} subtypes</span>,
                  onClick: () => push('/departments/' + store.id),
                  widthPx: departmentTableWidths.SUBTYPES
                },
                {
                  children: (
                    <Button
                      preset='link'
                      className={styles.suspendDepartment}
                      title='Suspend department'
                      onClick={() => onSuspendDepartmentClick(store)}
                    >
                      <IconDeleteCircle color="red" />
                    </Button>
                  ),
                  widthPx: departmentTableWidths.ACTIONS
                }
              ]}
            />
          )
        })}
      </TableBodyContainer>
      <PaginationButtons alwaysShow {...paginationInfo} style={{width: scrollX}} />
    </TableContainer>
  )
},

  DepartmentsTable = observer(DepartmentsTableComponent)
export { DepartmentsTable }
